import { render, staticRenderFns } from "./receipt_simply.vue?vue&type=template&id=be601eb0&scoped=true&"
import script from "./receipt_simply.vue?vue&type=script&lang=js&"
export * from "./receipt_simply.vue?vue&type=script&lang=js&"
import style0 from "./receipt_simply.vue?vue&type=style&index=0&id=be601eb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be601eb0",
  null
  
)

export default component.exports